import create, { SetState, StateCreator, StoreApi } from "zustand";
import {radioLables , tabsList , ExpenseData} from "../components/high-cost-patient-report/highCostPatientConstant";
import HighCostPatientService from "@services/high-cost-patient.service";
interface Tab {
  tabName: string,
  key : string,
  expenseType : string
}

interface HighCostPatientStore {
  clearTableData: () => void;
  clearStore: () => void;
  currentPage: any;
  setCurrentPage: (x: any) => void;
  sortData : any;
  setSortData : (x: any) => void;
  searchData : any;
  setSearchData : (x: any) => void;
  searchKeywordNew : any;
  setSearchKeywordNew : (x: any) => void;
  paginationFilterValue : string;
  setPaginationFilterValue : (x: any) => void;
  refreshDate : any;
  setRefreshDate : (x: any) => void;
  selectedOffice : any;
  setSelectedOffice : (x: any) => void;
  selectedInsurance :  string | undefined;
  setSelectedInsurance : (x: any) => void;
  selectedRegion :  any;
  setSelectedRegion : (x: any) => void;
  rowsPerPage : number,
  setRowsPerPage : (x: any) => void;
  columnData : any,
  setColumnData : (x: any) => void;
  activeTab : Tab,
  setActiveTab : (x: any) => void;
  expenseTypeDropdown : any;
  setExpenseTypeDropdown : (x: any) => void;
  showModel : any;
  setShowModel : (x: any) => void;
  selectedRecord: any;
  setSelectedRecord : (x: any) => void;
  insuranceLst: any;
  setInsuranceLst : (x: any) => void;
  officeNameLst: any;
  setOfficeNameLst : (x: any) => void;
  regionLst: any;
  setRegionLst : (x: any) => void;
  expenseData: any;
  setExpenseData: (x: any) => void;
  buildDone : boolean;
  setBuildDone : (x: any) => void;
}

let store: StateCreator<HighCostPatientStore, [], [], HighCostPatientStore> | StoreApi<HighCostPatientStore> = (set: SetState<HighCostPatientStore>) => ({
  currentPage: {"Part A" : 1 , "Part B" : 1 , "Part D" : 1 , "Total" : 1},
  setCurrentPage: (x) => {
    set(() => ({ currentPage: x }));
  },
  sortData: {"Part A" : {} , "Part B" : {} , "Part D" : {} , "Total" : {}},
  setSortData: (x) => {
    set(() => ({ sortData : x }));
  },
  searchData: {"Part A" : {} , "Part B" : {} , "Part D" : {} , "Total" : {}},
  setSearchData: (x) => {
    set(() => ({ searchData : x }));
  },
  searchKeywordNew : {"Part A" : {} , "Part B" : {} , "Part D" : {} , "Total" : {}},
  setSearchKeywordNew : (x) => {
    set(() => ({ searchKeywordNew : x }));
  },
  paginationFilterValue : radioLables[0].value,
  setPaginationFilterValue : (x) => {
    set(() => ({ paginationFilterValue : x }));
  },
  refreshDate : "",
  setRefreshDate : (x) => {
    set(() => ({ refreshDate : x }));
  },
  selectedOffice : {},
  setSelectedOffice : (x) => {
    set(() => ({ selectedOffice : x }));
  },
  selectedInsurance : undefined,
  setSelectedInsurance : (x) => {
    set(() => ({ selectedInsurance : x }));
  },
  selectedRegion : {},
  setSelectedRegion : (x) => {
    set(() => ({ selectedRegion : x }));
  },
  rowsPerPage : 10,
  setRowsPerPage : (x) => {
    set(() => ({ rowsPerPage : x }));
  },
  columnData : [{"Part A" : [] , "Part B" : [] , "Part D" : [] , "Total" : []}],
  setColumnData : (x) => {
    set(() => ({ columnData : x }));
  },
  activeTab : tabsList[0],
  setActiveTab : (x) => {
    set(() => ({ activeTab : x }));
  },
  expenseTypeDropdown : [],
  setExpenseTypeDropdown : (x) => {
    set(() => ({ expenseTypeDropdown : x }));
  },
  showModel : false,
  setShowModel : (x) => {
    set(() => ({ showModel : x }));
  },
  selectedRecord : {},
  setSelectedRecord : (x) => {
    set(() => ({ selectedRecord : x }));
  },
  insuranceLst : undefined,
  setInsuranceLst : (x) => {
    set(() => ({ insuranceLst : x }));
  },
  officeNameLst : [],
  setOfficeNameLst : (x) => {
    set(() => ({ officeNameLst : x }));
  },
  regionLst : [],
  setRegionLst : (x) => {
    set(() => ({ regionLst : x }));
  },
  expenseData: ExpenseData,
  setExpenseData: (x) => {
    set(() => ({ expenseData : x }));
  }, 
  buildDone: false,
  setBuildDone: (x) => {
    set(() => ({ buildDone : x }));
  },
  clearTableData : () => {
    set(() => ({ currentPage: {"Part A" : 1 , "Part B" : 1 , "Part D" : 1 , "Total" : 1} }));
    set(() => ({ sortData: {"Part A" : {} , "Part B" : {} , "Part D" : {} , "Total" : {}} }));
    set(() => ({ searchData: {"Part A" : {} , "Part B" : {} , "Part D" : {} , "Total" : {}} }));
    set(() => ({ searchKeywordNew: {"Part A" : {} , "Part B" : {} , "Part D" : {} , "Total" : {}} }));
  },
  clearStore: () => {
    set(() => ({ currentPage: {"Part A" : 1 , "Part B" : 1 , "Part D" : 1 , "Total" : 1} }));
    set(() => ({ sortData: {"Part A" : {} , "Part B" : {} , "Part D" : {} , "Total" : {}} }));
    set(() => ({ searchData: {"Part A" : {} , "Part B" : {} , "Part D" : {} , "Total" : {}} }));
    set(() => ({ searchKeywordNew: {"Part A" : {} , "Part B" : {} , "Part D" : {} , "Total" : {}} }));
    set(() => ({ paginationFilterValue:  radioLables[0].value}));
    set(() => ({ refreshDate: "" }));
    set(() => ({ selectedRegion : {}}));
    set(() => ({ selectedOffice: {} }));
    set(() => ({ selectedInsurance : undefined}));
    set(() => ({ rowsPerPage : 10}));
    set(() => ({ columnData : {"Part A" : [] , "Part B" : [] , "Part D" : [] , "Total" : []}}));
    set(() => ({ activeTab : tabsList[0]}));
    set(() => ({ expenseTypeDropdown : []}));
    set(() => ({ showModel : false}));
    set(() => ({ insuranceLst : []}));
    set(() => ({ officeNameLst : []}));
    set(() => ({ regionLst : []}));
    set(() => ({ expenseData : ExpenseData}));
    set(() => ({ buildDone : false}));
    set(() => ({ selectedRecord : {}}));
    //to delete the build table
    function dropTable() {
      HighCostPatientService.dropTable().subscribe({
        next: (v) => console.log(v),
        error: (e) => {
          console.log(e)
        },
      });
    }
    dropTable()
  },
});

export const useHighCostPatientStore = create(store);
